module.exports = __webpack_public_path__ + "img/icon_zhuancang_delete@3x.80ae77fb.png";